import type { AppApi } from '@wix/wix-data-client-common'
import { PAGE_TYPES } from '@wix/wix-data-client-common'
import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import type { Schema } from '@wix/wix-data-schema-types'
import { MAIN_SLUG_FIELD_KEY } from '../../slug/constants'
import { generateUniquePrefix } from '../generateUniquePrefix'

export const getRouterPrefixAndPattern = async ({
  editorSdkProxy,
  appApi,
  newCollectionSchema,
}: {
  editorSdkProxy: EditorSDK
  appApi: AppApi
  newCollectionSchema: Schema
}) => {
  const newRouterPrefix = await generateUniquePrefix({
    inputsForPrefix: [newCollectionSchema.displayName, newCollectionSchema.id],
    editorSdkProxy,
    appApi,
    pageType: PAGE_TYPES.ITEM,
  })

  const pattern = `/{${MAIN_SLUG_FIELD_KEY}}`

  return { newRouterPrefix, pattern }
}
